import { Button, Col, Modal, Row } from '@orobix/orobix-fe-components'
import { useTranslation } from 'react-i18next'

interface MaxImagesAlertModalProps {
  handleClose: () => void
  handleConfirm: () => void
  isAnomaly: boolean
}

const MaxImagesAlertModal = ({
  handleClose,
  handleConfirm,
  isAnomaly,
}: MaxImagesAlertModalProps) => {
  const { t } = useTranslation()

  return (
    <Modal
      size="sm"
      onCloseRequest={() => {
        handleClose()
      }}
      title={t('High number of selected images')}
      footer={
        <Row noBottomPadding vAlignCenter>
          <Col>
            <Button
              onClick={(e) => {
                e.preventDefault()
                handleClose()
              }}
              label={t('Cancel')}
              type="default"
              buttonType="button"
            />
            <Button
              onClick={(e) => {
                e.preventDefault()
                handleClose()
                handleConfirm()
              }}
              label={t('Start training')}
              type="action"
              buttonType="button"
            />
          </Col>
        </Row>
      }
    >
      <br />
      <p>
        {isAnomaly
          ? t(
              'The number of images selected is very high. This may impact model performance or lead to extended training times, potentially lasting several hours.'
            )
          : t(
              'The number of images selected is very high. The training process may take several hours to complete.'
            )}
      </p>
      <br />
      <p>
        {isAnomaly
          ? t(
              'Reducing the number of images is recommended to optimize processing speed and model efficiency.'
            )
          : t('Reducing the number of images is recommended.')}
      </p>
    </Modal>
  )
}

export default MaxImagesAlertModal
